<template>
    <div class="jewelry-slider">
        <h2 v-if="result.messages && result.messages.title" class="def-header-2">{{ result.messages.title }}</h2>
        <DefSliderWrapper v-if="screenWidth >= 992">
            <swiper
                :modules="modules"
                :slides-per-view="4"
                :space-between="4"
                :pagination="{ clickable: true }"
            >
                <swiper-slide
                    v-for="(item, i) in result.items"
                    :key="i"
                >
                    <jewelry-card :result="item"/>
                </swiper-slide>
            </swiper>
        </DefSliderWrapper>
        <PerfectScrollbar v-else class="jewelry-slider__mobile">
            <jewelry-card v-for="(item, i) in result.items" :key="i" :result="item"/>
        </PerfectScrollbar>
        <div v-if="result.link && result.link.name && result.link.href" class="jewelry-slider__button">
            <a  :href="result.link.href" class="def-button">{{ result.link.name }}</a>
        </div>
    </div>
</template>

<script>
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
    name: 'JewelrySlider',
    selector: '.jewelry-slider',
    props: {
        result: {
            type: Object,
            default: () => ({
                "messages": {"title": "Почитати ще"},
                // "link": {"name": "Читати блог", "href": "/blog/"},
                "items": [{
                    "name": "Test 2",
                    "text": "Анонс",
                    "date": "10/22/2020 01:38:18 pm",
                    "detailPage": "/blog/test-2/",
                    "picture": {"alt": "Test 2", "src": "/local/templates/love-you/images/crash_photo.jpeg"},
                    tags: ["Odit accusamus nisi voluptatem reiciendis et tenetur non. (ua)","Et doloremque esse omnis nesciunt quidem quaerat autem. (ua)"]
                }, {
                    "name": "Test",
                    "text": "",
                    "date": "10/21/2020 04:48:37 pm",
                    "detailPage": "/blog/test/",
                    "picture": {"alt": "Test", "src": "/upload/iblock/e59/e59558d5211e98f8d207d1db814463c2.jpeg"}
                }]
            })
        }
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            modules: [Pagination],
        }
    },
};
</script>

<style lang="scss">
.jewelry-slider {
    margin: 50px 0;
    background-image: url(/local/templates/love-you/images/decor2.png);
    background-repeat: no-repeat;
    background-position: left;
    background-size: contain;
    position: relative;
    z-index: 1;
    @include point-md {
        margin: 80px 0;
    }
    @include point-lg {
        margin: 104px 0;
        background-position: center;
    }

    &__button {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 24px;
        @include point-lg{
            margin-top: 32px;
        }
    }

    &__mobile {
        display: flex;
        overflow-x: auto;
        padding-bottom: 20px;

        & > * {
            width: 240px;
            flex-shrink: 0;
            @include point-md {
                width: 345px;
            }

            &:not(:last-child) {
                margin-right: 16px;
            }
        }
    }

    .def-button {
        font-size: rem(14);
        text-transform: uppercase;
        height: 48px;
        @include point-lg {
            height: 56px;
            font-size: rem(18);
            padding: 0 48px;
        }
    }
}
</style>